import React from 'react';
import { useSelector } from 'react-redux';
import SwitchToggle from '../../../../UI/SwitchToggle';
import classes from './QuestionSettings.module.css';

const QuestionSettings = ({ config, data, id, points, setQuestionFirstLevelFields, setQuestionInnerData }) => {
    const { texts } = useSelector(state => state.translate);


    const changeConfig = (conf) => {
        let newData = {};
        newData[conf.name] = !data[conf.name]
        approveSurveyQuestions(conf , newData)
        setQuestionInnerData(newData)
    }

    const approveSurveyQuestions = (conf, newData) => {
        if(conf.name=== 'survey' ){
            newData.options = data.options.map(opt => {
                return { ...opt, correct: newData[conf.name] };
              });
        }
    }

    return (
        <div>
            <div className={classes.Toogles}>
                <p className={classes.Title}>{texts.questionType}</p>
                {config && config.map((conf, index) =>
                    <div className={classes.ToogleSwitch}>
                        <SwitchToggle
                            id={id + index}
                            checked={data[conf.name]}
                            setChecked={() => changeConfig(conf)} />
                        <p className={classes.ToogleText}>{texts[conf.text]}</p>
                    </div>)}
            </div>
            <div className={classes.Footer}>
                <p className={classes.Title}>{texts.score2}</p>
                <div className={classes.Points}>
                    <div className={classes.ToogleText}>{texts.pointsToQuestion}</div>
                    <input type={'number'} min={1} value={points} onChange={(e) => setQuestionFirstLevelFields({ points: e.target.value })} className={classes.InputPoints}></input>
                </div>
            </div>
        </div>
    );
};

export default QuestionSettings;